import { ACCEPTED_FILE_TYPES, getFileId, toBase64 } from '@shared/utils'
import { isEscalationTask } from '@shared/utils/src/TasksHelper/TasksHelper'

export const ACCEPT_ATTRIBUTE = Object.entries(ACCEPTED_FILE_TYPES)
  .flatMap(([mime, extensions]) => [mime, ...extensions])
  .join(',')

export const ALLOWED_DESCRIPTION = 'PNG, JPG, HEIC, TIFF or PDF · up to 25 MB each'

export const MAX_SIZE = 25 * 1024 * 1024

export const NAME_MAX_LENGTH = 32

export const AttachmentStatus = {
  Staged: 'staged',
  Uploading: 'uploading',
  Error: 'error',
}

export const isTaskOwnedAttachments = (task) => isEscalationTask(task) || !task.patientId

export function validateFile(file) {
  if (!Object.keys(ACCEPTED_FILE_TYPES).includes(file.type)) return 'File type is not allowed'
  if (file.size > MAX_SIZE) return 'File is larger than 25 MB'
  return null
}

export function toStagedFile(file) {
  return {
    id: getFileId(file),
    file,
    name: splitExtension(file.name)[0],
    previewed: false,
    status: AttachmentStatus.Staged,
    reason: validateFile(file),
  }
}

export function splitExtension(filename) {
  const index = filename.lastIndexOf('.')
  return index > 0 ? [filename.slice(0, index), filename.slice(index)] : [filename, '']
}

export function resolveFilename(file, name) {
  const [base, extension] = splitExtension(file.name)
  return `${name.trim() || base}${extension}`
}

export const displayName = (item) => resolveFilename(item.file, item.name)

export async function toUploadPayload(file, filename = file.name) {
  const content = await toBase64(file)
  return { filename, mimetype: file.type, content: content.split(',')[1] }
}

export function filesFromDataTransfer(dataTransfer) {
  return Array.from(dataTransfer?.files ?? [])
}

export const hasFiles = (dataTransfer) => Array.from(dataTransfer?.types ?? []).includes('Files')
